/* eslint-disable consistent-return */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import Dropdown from '../Shared/Dropdown';
import {
  fetchDoctorById, updateDoctor, fetchspecializations, fetchDistricts,
} from '../../Services/apiService';

const UpdateDoctor = () => {
  const [specializations, setSpecializations] = useState([]);
  const [districts, setDistricts] = useState([]);
  const categories = [
    { id: 'Diagnostic', name: 'Diagnostic' },
    { id: 'Clinic', name: 'Clinic' },
  ];
  const {
    handleSubmit, register, control, reset,
  } = useForm();

  const [doctorId, setDoctorId] = useState('');
  const [loading] = useState(false);

  // Fetch specializations and districts for dropdowns
  useEffect(() => {
    const fetchData = async () => {
      const specializationData = await fetchspecializations();
      setSpecializations(specializationData);
      const districtData = await fetchDistricts();
      setDistricts(districtData);
    };
    fetchData();
  }, []);

  // Fetch doctor data based on ID
  const fetchDoctor = async () => {
    if (!doctorId) return alert('Please enter a valid Doctor ID.');

    const data = await fetchDoctorById(doctorId);
    console.log('Doctor data in fetchDoctorById:', data); // Debug log
    if (data) {
      reset({
        id: doctorId,
        name: data.name,
        qualification: data.qualification,
        experience: data.experience,
        order: data.order,
        specialization_id: data.specializations?.[0]?.id || '', // Assume first specialization
        district_id: data.chambers?.[0]?.district_id || '', // Assume first chamber's district
        chamber_attributes: {
          id: data.chambers?.[0]?.id || '', // First chamber ID
          name: data.chambers?.[0]?.name || '',
          address: data.chambers?.[0]?.address || '',
          category: data.chambers?.[0]?.category || '',
        },
        doctor_schedules_attributes: {
          id: data.doctor_schedules?.[0]?.id || '', // First schedule ID
          available_day: data.doctor_schedules?.[0]?.available_day || '',
          available_time: data.doctor_schedules?.[0]?.available_time || '',
          contact: data.doctor_schedules?.[0]?.contact || '',
        },
      });
    } else {
      alert('Doctor not found. Please check the ID.');
    }
  };

  const onSubmit = async (data) => {
    const payload = {
      doctor: {
        id: doctorId,
        name: data.name,
        qualification: data.qualification,
        experience: data.experience,
        order: data.order,
        doctor_specializations_attributes: [
          { specialization_id: parseInt(data.specialization_id, 10) },
        ],
        doctor_schedules_attributes: [
          {
            id: data.doctor_schedules_attributes.id, // Keep ID if editing
            available_day: data.doctor_schedules_attributes.available_day,
            available_time: data.doctor_schedules_attributes.available_time,
            contact: data.doctor_schedules_attributes.contact,
            chamber_attributes: {
              id: data.chamber_attributes.id, // Keep ID if editing
              name: data.chamber_attributes.name,
              address: data.chamber_attributes.address,
              category: data.chamber_attributes.category,
              district_id: parseInt(data.district_id, 10),
            },
          },
        ],
      },
    };

    console.log('Payload to update:', payload);

    const response = await updateDoctor(payload);
    if (response) {
      alert('Doctor information updated successfully!');
      reset();
    } else {
      alert('Failed to update doctor information. Please try again.');
    }
  };

  return (
    <div className="update-doctor-form p-12 mt-12">
      <h2>Update Doctor</h2>
      <div className="fetch-doctor-section">
        <label htmlFor="doctorId">Enter Doctor ID:</label>
        <input
          type="text"
          id="doctorId"
          placeholder="Doctor ID"
          value={doctorId}
          onChange={(e) => setDoctorId(e.target.value)}
        />
        <button type="button" onClick={fetchDoctor} disabled={loading}>
          {loading ? 'Loading...' : 'Fetch Doctor'}
        </button>
      </div>

      <form onSubmit={handleSubmit(onSubmit)}>
        <Controller
          name="specialization_id"
          control={control}
          render={({ field }) => (
            <Dropdown
              {...field}
              options={specializations}
              label="Select Specialization"
              valueType="number"
            />
          )}
        />

        <Controller
          name="district_id"
          control={control}
          render={({ field }) => (
            <Dropdown {...field} options={districts} label="Select District" />
          )}
        />
        <Controller
          name="chamber_attributes.category"
          control={control}
          render={({ field }) => (
            <select
              {...field}
              value={field.value || ''}
              onChange={(e) => field.onChange(e.target.value)}
            >
              {categories.map((cat) => (
                <option key={cat.id} value={cat.id}>
                  {cat.name}
                </option>
              ))}
            </select>
          )}
        />

        <label htmlFor="name">Name</label>
        <input
          type="text"
          id="name"
          {...register('name', { required: 'Name is required' })}
        />

        <label htmlFor="order">Order</label>
        <input type="text" id="order" {...register('order')} />

        <label htmlFor="qualification">Qualification</label>
        <input
          type="text"
          id="qualification"
          {...register('qualification', { required: 'Qualification is required' })}
        />

        <label htmlFor="experience">Experience</label>
        <input
          type="text"
          id="experience"
          {...register('experience', { required: 'Experience is required' })}
        />

        <fieldset>
          <legend>Chamber Information</legend>
          <label htmlFor="chamber_attributes.name">Chamber Name</label>
          <input
            type="text"
            id="chamber_attributes.name"
            {...register('chamber_attributes.name')}
          />

          <label htmlFor="chamber_attributes.address">Address</label>
          <input
            type="text"
            id="chamber_attributes.address"
            {...register('chamber_attributes.address')}
          />
        </fieldset>

        <fieldset>
          <legend>Doctor Schedule</legend>
          <label htmlFor="doctor_schedules_attributes.available_day">Available Day</label>
          <input
            type="text"
            id="doctor_schedules_attributes.available_day"
            {...register('doctor_schedules_attributes.available_day')}
          />

          <label htmlFor="doctor_schedules_attributes.available_time">Available Time</label>
          <input
            type="text"
            id="doctor_schedules_attributes.available_time"
            {...register('doctor_schedules_attributes.available_time')}
          />

          <label htmlFor="doctor_schedules_attributes.contact">Contact</label>
          <input
            type="text"
            id="doctor_schedules_attributes.contact"
            {...register('doctor_schedules_attributes.contact')}
          />
        </fieldset>

        <button type="submit">Update Doctor</button>
      </form>
    </div>
  );
};

export default UpdateDoctor;
